import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '../pages/HomePage.vue';
import AboutPage from '../pages/AboutPage.vue';
import comNews from '../pages/comNews.vue';
import enerGy from '../pages/comNew.vue';
import comTalent from '../pages/comTalent.vue';
import comAbout from '../pages/comAbout.vue';
import comBrand from '../pages/comBrand.vue';


Vue.use(VueRouter);

const router = new VueRouter({
  // 您的路由配置
  routes: [
     { path: '/', component: HomePage },
  { path: '/about', component: AboutPage },
  { path: '/news', component: comNews },
  { path: '/talent', component: comTalent },
  { path: '/abouts', component: comAbout },
  { path: '/brand', component: comBrand },
  { path: '/energy', component: enerGy },
  ]
})

// const routes = [
//   { path: '/', component: HomePage },
//   { path: '/about', component: AboutPage },
//   { path: '/news', component: comNews },
//   { path: '/talent', component: comTalent },
//   { path: '/abouts', component: comAbout },
//   { path: '/brand', component: comBrand },
// ];

// 添加全局路由守卫
router.beforeEach((to, from, next) => {
  // 在导航前确保页面滚动到顶部
  window.scrollTo(0, 0);
  next();
});

// 同时捕获导航重复错误
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};


// const router = new VueRouter({
//   mode: 'history', // 使用HTML5 History模式
//   routes // 简写，等同于routes: routes
// });

export default router;
